export default "__VITE_ASSET__DJUm3Iba__"